export const environment = {
  apiUrl: "https://sar-api.yobi.farm/",
  version: "e7a716c421781ae2c2561ca318ce0cfbf4c84cb4", //will be replaced via the build script
  versionName: "0.41.0", // TODO: increment at each deployment
};
